import { BACKEND_URL_PREFIX } from '../assets/const';
import { buildDefaultHeaders } from './helper';
import moment from 'moment';
import { AUTH_COMPLETED, SET_AUTH_LOADING, SIGNED_OUT } from './types';
import { createNotification } from '../components/Notifications/Notifications';
import { getError } from '../utils/getError';

const TOKEN_UPDATING_INTERVAL = 190;

const getTimeToExpireToken = (getState) => {
  const { valid_until } = getState().auth;
  return moment(valid_until).diff(moment.utc()) / 1000 / 60;
};

export const checkAndUpdateToken = () => async (dispatch, getState) => {
  // const timeToExpire = getTimeToExpireToken(getState);
  // if (timeToExpire < TOKEN_UPDATING_INTERVAL) {
  //   try {
  //     const response = await fetch(
  //       `${BACKEND_URL_PREFIX}/auth/login`,
  //       buildDefaultHeaders(getState)
  //     );
  //     if (response.ok) {
  //       const result = await response.json();
  //       if (result.error && result.error.code === 401) {
  //         // dispatch(signOut());
  //       } else {
  //         dispatch({ type: AUTH_COMPLETED, user: result });
  //       }
  //     } else {
  //       dispatch(signOut());
  //     }
  //   } catch (ERR) {
  //     dispatch({ type: ERROR, payload: ERR });
  //     // dispatch(signOut());
  //   }
  // }
};

// export const auth = (values) => async (dispatch, getState) => {
//   dispatch({ type: SET_AUTH_LOADING, payload: true });

//   try {
//     const { username, password } = values;
//     const tok = `${username.trim()}:${password.trim()}`;
//     const hash = window.btoa(unescape(encodeURIComponent(tok)));
//     const Authorization = `Basic ${hash}`;

//     const response = await fetch(`${BACKEND_URL_PREFIX}/auth/login`, {
//       method: 'POST',
//       headers: {
//         Authorization,
//         'Content-Type': 'application/json',
//       },
//     });

//     const result = await response.json();

//     // === если сервер вернул токен ===
//     if (response.ok && result?.token) {
//       dispatch({ type: AUTH_COMPLETED, payload: result });
//       createNotification('success', 'Авторизация успешна!');
//       return;
//     }

//     // === обработка известных ошибок ===
//     if (result?.error) {
//       const errorText =
//         typeof result.error === 'string'
//           ? result.error
//           : result.error.message || 'Ошибка авторизации';

//       if (errorText.includes('invalid') || response.status === 401) {
//         createNotification('error', 'Неверный логин или пароль');
//       } else if (response.status >= 500) {
//         createNotification('error', 'Ошибка сервера. Повторите попытку позже');
//       } else {
//         createNotification('error', errorText);
//       }
//       return;
//     }

//     // === если сервер не вернул JSON или пусто ===
//     createNotification('error', 'Неожиданный ответ сервера');
//   } catch (ERROR) {
//     console.error('auth error:', ERROR);
//     createNotification('error', 'Не удалось подключиться к серверу');
//   } finally {
//     dispatch({ type: SET_AUTH_LOADING, payload: false });
//   }
// };

export const auth = (values) => async (dispatch) => {
  dispatch({ type: SET_AUTH_LOADING, payload: true });

  try {
    const { username, password } = values;

    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username.trim(),
        password: password.trim(),
      }),
    });

    let result;
    try {
      getError({ response, dispatch });
      result = await response.json();
    } catch {
      createNotification('error', 'Некорректный ответ от сервера');
      return;
    }

    // === УСПЕШНЫЙ ВХОД ===
    if (response.ok && result?.access_token) {
      const userData = {
        token: result.access_token,
        user: result.user,
      };

      // сохраняем токен локально
      localStorage.setItem('access_token', result.access_token);
      localStorage.setItem('user', JSON.stringify(result.user));

      dispatch({ type: AUTH_COMPLETED, payload: userData });
      createNotification('success', `Добро пожаловать, ${result.user.username}!`);
      return;
    }

    // === ОШИБКИ ===
    if (!response.ok || result?.error) {
      const errorText =
        typeof result.error === 'string'
          ? result.error
          : result.error?.message || 'Ошибка авторизации';

      if (response.status === 401) {
        createNotification('error', 'Неверный логин или пароль');
      } else if (response.status >= 500) {
        createNotification('error', 'Ошибка сервера. Повторите попытку позже');
      } else {
        createNotification('error', errorText);
      }
      return;
    }

    // === fallback ===
    createNotification('error', 'Неожиданный ответ сервера');
  } catch (error) {
    createNotification('error', 'Не удалось подключиться к серверу');
  } finally {
    dispatch({ type: SET_AUTH_LOADING, payload: false });
  }
};

export const signOut = () => async (dispatch) => {
  dispatch({ type: SIGNED_OUT });
};

export const registerUser = (values, navigate) => async (dispatch, getState) => {
  dispatch({ type: SET_AUTH_LOADING, payload: true });

  try {
    const { username, email, password, confirmPassword } = values;

    if (password !== confirmPassword) {
      createNotification('error', 'Пароли не совпадают');
      return;
    }

    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...buildDefaultHeaders(getState).headers,
      },
      body: JSON.stringify({
        username: username.trim(),
        email: email.trim(),
        password: password.trim(),
        code: 'cat2000',
      }),
    });

    getError({ response, dispatch });
    const result = await response.json();
    // === успешная регистрация ===
    if (response.ok && result?.message === 'User created successfully') {
      createNotification('success', 'Регистрация прошла успешно!');
      console.log('✅ Новый пользователь:', result.user);

      // небольшая пауза, чтобы пользователь увидел уведомление
      setTimeout(() => {
        navigate('/auth');
      }, 1500);

      return;
    }

    // Ошибка: пользователь уже существует
    if (result?.error?.includes('already exists')) {
      createNotification('warning', 'Пользователь с таким логином или email уже существует');
      return;
    }

    // Все остальные ошибки
    createNotification('error', result.error || 'Ошибка при регистрации');
  } catch (error) {
    console.error('registerUser error:', error);
    createNotification('error', 'Не удалось выполнить регистрацию');
  } finally {
    dispatch({ type: SET_AUTH_LOADING, payload: false });
  }
};
